import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { Download } from 'lucide-react';
import CurvedLoop from './CurvedLoop';
import Shuffle from './Shuffle';
import TerminalHero from './TerminalHero';
import TypeCycle from './TypeCycle';
import './Hero.css';

const Hero = () => {
  const heroRef = useRef(null);
  const [time, setTime] = useState('');

  useEffect(() => {
    const tick = () => {
      setTime(
        new Date().toLocaleTimeString('en-GB', {
          timeZone: 'Asia/Karachi',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        })
      );
    };
    tick();
    const timer = setInterval(tick, 1000);
    return () => clearInterval(timer);
  }, []);

  const handleMouseMove = (e) => {
    const el = heroRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    el.style.setProperty('--mx', `${e.clientX - rect.left}px`);
    el.style.setProperty('--my', `${e.clientY - rect.top}px`);
  };

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero" ref={heroRef} onMouseMove={handleMouseMove}>
      <div className="hero-spotlight" aria-hidden="true" />

      <div className="container">
        <div className="hero-curved-headline">
          <CurvedLoop
            marqueeText="AI ✦ IOT ✦ DEVELOPER ✦"
            speed={1.5}
            curveAmount={60}
            direction="left"
            interactive={false}
            className="hero-curved-text"
          />
        </div>

        <div className="hero-content">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="hero-text"
          >
            <Shuffle
              text="Qazi Absaar"
              tag="p"
              className="hero-name-shuffle"
              textAlign="left"
              shuffleDirection="right"
              duration={0.35}
              animationMode="evenodd"
              shuffleTimes={1}
              ease="power3.out"
              stagger={0.03}
              threshold={0.1}
              triggerOnce={true}
              triggerOnHover={true}
              respectReducedMotion={true}
              colorFrom="#94a3b8"
              colorTo="#E6002B"
            />
            <TypeCycle
              className="hero-roles"
              roles={[
                'AI/ML Engineer',
                'IoT & Embedded Systems Developer',
                'Automation Enthusiast',
                'Full-Stack Problem Solver'
              ]}
            />
            <div className="hero-location">
              Islamabad, Pakistan
            </div>
            <div className="hero-buttons">
              <button className="btn" onClick={scrollToContact}>
                Get In Touch
              </button>
              <a
                href="/Qazi Absaar's Resume.pdf"
                className="btn btn-outline"
                download
              >
                <Download size={18} />
                Download CV
              </a>
            </div>
            <div className="social-logs">
              <a href="https://github.com/QaziAbsaar" target="_blank" rel="noopener noreferrer" aria-label="GitHub" className="log-link">
                <img src="/images/github.gif" alt="" className="log-icon log-icon-invert" />
              </a>
              <a href="https://www.linkedin.com/in/qazi-absaar/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="log-link">
                <img src="/images/Linkedin.gif" alt="" className="log-icon" />
              </a>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="hero-visual"
          >
            <TerminalHero />
            <div className="hero-bento">
              <div className="bento-card">
                <span className="bento-label">Local time</span>
                <span className="bento-value">{time || '--:--:--'}</span>
                <span className="bento-sub">Asia/Karachi</span>
              </div>
              <div className="bento-card">
                <span className="bento-label">Currently building</span>
                <span className="bento-value">AI agents</span>
                <span className="bento-sub">autonomous sales systems</span>
              </div>
              <div className="bento-card">
                <span className="bento-label">Edge fleet</span>
                <span className="bento-value">120+</span>
                <span className="bento-sub">devices managed @ CV Lab</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
